import { startCase, cloneDeep } from "lodash";

// Store Imports
import store from "../../store";

import { arrayHasObjectWithKeyAndVal } from "../../utils/globalUtils";

export const addCheckFlagToPermissions = (orgPermissions, rolePermissions) => {
  orgPermissions = orgPermissions.map(item => {
    if (Object.prototype.hasOwnProperty.call(item, "check")) {
      delete item.check;
    }
    return item;
  });
  if (orgPermissions && rolePermissions) {
    const arr = orgPermissions.map(orgPermission => {
      // eslint-disable-next-line consistent-return
      rolePermissions.forEach(rolePermission => {
        if (orgPermission.id === rolePermission.id) {
          orgPermission.check = true;
          return orgPermission;
        }
      });
      return orgPermission;
    });
    return arr;
  }
  return [];
};

export const categorizePermissions = orgPermissions => {
  const categorizedPermissions = [];
  orgPermissions.map(permission => {
    if (
      categorizedPermissions.length === 0 ||
      !arrayHasObjectWithKeyAndVal(
        categorizedPermissions,
        "category",
        permission.category,
      )
    ) {
      const categoryObj = {};
      categoryObj.category = permission.category;
      categoryObj.categoryLabel = startCase(permission.category).toUpperCase();
      categoryObj.permissions = [permission];
      categorizedPermissions.push(categoryObj);
    } else {
      categorizedPermissions.every(categoryObj => {
        if (categoryObj.category === permission.category) {
          categoryObj.permissions.push(permission);
          return false;
        }
        return true;
      });
    }
    return null;
  });
  return categorizedPermissions;
};

export const updateTeammateList = (
  newTeammate,
  isUpdate,
  isInviteOrReInviteCase,
) => {
  const reduxState = store.getState();
  const { teammatesList } = reduxState.SettingsStore;
  const updateteammatesList = cloneDeep(teammatesList);
  if (newTeammate) {
    if (isUpdate || isInviteOrReInviteCase) {
      updateteammatesList.forEach(teammate => {
        if (teammate.id === newTeammate.id) {
          teammate.roles = newTeammate.roles;
          teammate.usergroups = newTeammate.usergroups;
          teammate.is_invited = newTeammate.is_invited;
          teammate.is_external = newTeammate.is_external;
        }
      });
    } else {
      updateteammatesList.push(newTeammate);
    }
  }

  return updateteammatesList;
};
